export const OTP_ERROR_MESSAGE = "OTP is Wrong";
export const MANY_ATTEMPT_ERROR_MESSAGE =
  "Too many login attempts. Please try again after 15min.";
